import { type Line, type Vector2D } from "./drawing/models";

export const getParticipantName = (participant: server.dto.ESignParticipant) => {
  if (participant.contact?.contactId) {
    return participant.contact.name.fullName;
  }

  return participant.linkedToUser.fullName;
};

export const svgToLines = (svg: string) => {
  const domParser = new DOMParser();
  const dom = domParser.parseFromString(svg, "text/html");
  const paths = Array.from(dom.documentElement.getElementsByTagName("path"));

  const lines: Line[] = paths.map((pathEl) => {
    const path = pathEl.getAttribute("d").replace("M", "");
    const points = path.split(" L ").map<Vector2D>(p => {
      const [x, y] = p.trim().split(" ");
      return { x: parseFloat(x), y: parseFloat(y) };
    });
    return { points };
  });

  return lines;
};